$(($) => {
	const mapWrapper = $('.wp-block-e25m-custom-location-map');
	if (mapWrapper.length === 0) return;

	const duration = 500;

	const firstLevelLi = mapWrapper.find('.accordion > ul > li');

	const slideUpAll = (duration) =>
		firstLevelLi
			.find('>ul')
			.slideUp(duration)
			.parent()
			.removeClass('expanded');

	slideUpAll(0);

	firstLevelLi.find('>p').on('click', (event) => {
		const childUl = $(event.target).next();

		if (childUl.parent().hasClass('expanded')) {
			childUl.slideUp(duration);
			childUl.parent().removeClass('expanded');
			return;
		}

		slideUpAll(duration);
		childUl.slideDown(duration).parent().addClass('expanded');
	});
});
